import React, { useState } from 'react'
import strings from '../../../Utils/strings';
import SpecialtyCard from '../../../Widgets/speciality/specialityCard';
import utilFunctions from '../../../Utils/utilFunctions';
import clinicService from '../../../Services/clinicService';
import toast from "react-hot-toast";
import { t } from '../../../Utils/translate';
import utils from '../../../Utils';
import Widgets from '../../../Widgets';

function SpecialtyItem({ item, onEditItem, index, onEditComplete, isSpecialityAdd, isEdited, isSpecialityEditable, isSpecialityEdited, isSearching }) {
    const [departmentName, setDepartmentName] = useState("")
    const [isEditable, setIsEditable] = useState(false)
    const [departmentNameErr, setDepartmentNameErr] = useState("")
    const [departmentId, setDepartmentId] = useState()
    const [newSpecialityName, setNewSpecialityName] = useState("")
    const [isSpecialityDelete, setIsSpecialityDelete] = useState(false)
    const [isSpecialityEditPopUp, setIsSpecialityEditPopUp] = useState(false)

    const handleEditClick = () => {
        if (item.isEditable && !isSpecialityAdd) {
            setDepartmentName(item.label)
            setNewSpecialityName(item.label)
            onEditItem(index)
            setIsEditable(!isEditable);
            isSpecialityEditable(!isEditable)
            setDepartmentId(item.value)
        }
    };

    const handleCloseDepart = () => {
        setIsEditable(!isEditable);
        isSpecialityEditable(!isEditable)
        onEditComplete()
        setDepartmentName("")
        setDepartmentNameErr("")
    };

    const handleSpecialtyInputChanges = (e) => {
        utilFunctions.handleSpecialtyInputChanges(e, setNewSpecialityName, setDepartmentNameErr)
    }
    const editSpeciality = async () => {
        try {
            const body = {
                departmentId: departmentId,
                departmentName: newSpecialityName
            }
            const response = await clinicService.editSpeciality(body);
            if (response && response.status === true) {
                toast.dismiss();
                toast.success(response.data)
                setIsEditable(false);
                isEdited(true)
                onEditComplete()
                isSpecialityEditable(false)
                setIsSpecialityEditPopUp(false)
                isSpecialityEdited(true)
            } else {
                setDepartmentNameErr(response.data.error_message)
                setIsEditable(false);
                isSpecialityEditable(!isEditable)
                onEditComplete()
                setIsSpecialityEditPopUp(false)
                utilFunctions.clearErrorMessages(setDepartmentNameErr)
                isSearching.length > 0 ? setTimeout(() => {
                    isSpecialityEdited(true)
                }, 4000) : isSpecialityEdited(false);
            }

        } catch { }
    }

    const deleteSpeciality = async () => {
        try {
            if (item.isEditable && !isSpecialityAdd) {
                const response = await clinicService.deleteSpeciality(item.value);
                if (response && response.status === true) {
                    toast.dismiss();
                    ((response.data === "Speciality deleted sucessfully!")?toast.success(t("Speciality deleted sucessfully!")):toast.success(response.data));
                    setIsEditable(false);
                    isEdited(true)
                    onEditComplete()
                    setIsSpecialityDelete(false)
                    isSpecialityEdited(true)
                } else {
                    setDepartmentNameErr(response.data.error_message)
                    setIsEditable(false);
                    onEditComplete()
                    utilFunctions.clearErrorMessages(setDepartmentNameErr)
                    setIsSpecialityDelete(false)
                    isSearching.length > 0 ? setTimeout(() => {
                        isSpecialityEdited(true)
                    }, 4000) : isSpecialityEdited(false);
                }
            }
        } catch { }
    }

    return (
        <div style={{ maxHeight: '100vh', overflowY: 'auto' }}>
            {isSpecialityEditPopUp ? (
                <Widgets.AppDialog
                    setVisibility={(e) => {
                        setIsSpecialityEditPopUp(e);
                    }}
                    widthType={utils.constants.dialogWidthType.small}
                    dialogTitle={t("labelSpeciality")}
                    dialogNegativeBtnText={t("noBtn")}
                    dialogPositiveBtnText={t("yesBtn")}
                    dialogNegativeBtnCall={() => {
                        setIsSpecialityEditPopUp(false);
                    }}
                    dialogPositiveBtnCall={() => {
                        editSpeciality()
                    }}
                    view={
                        <div className="text-center">
                            <i className="ri-pencil-line manage-icon bg-icon"></i>
                            <div className="d-flex justify-content-center">
                                <span className="text-doctor mt-1">{t("askToEditSpeciality")}
                                    <span className='speciality-title'> {item.label}</span> {t("specialityDelete")}</span>
                            </div>
                        </div>

                    }
                />
            ) : null}
            {isSpecialityDelete ? (
                <div>
                    <Widgets.AppDialog
                        setVisibility={(e) => {
                            setIsSpecialityDelete(e);
                        }}
                        widthType={utils.constants.dialogWidthType.small}
                        dialogTitle={t("labelSpeciality")}
                        dialogNegativeBtnText={t("noBtn")}
                        dialogPositiveBtnText={t("yesBtn")}
                        dialogNegativeBtnCall={() => {
                            setIsSpecialityDelete(false);
                        }}
                        dialogPositiveBtnCall={() => {
                            deleteSpeciality()
                        }}
                        view={
                            <div className="text-center">
                                <i className="ri-delete-bin-line manage-icon bg-icon"></i>
                                <div className="d-flex justify-content-center">
                                    <span className="text-doctor mt-1">{t("askToDeleteSpeciality")}
                                        <span className='speciality-title'> {item.label}</span> {t("specialityDelete")}</span>
                                </div>
                            </div>
                        }
                    />
                </div>
            ) : null}
            <SpecialtyCard
                isEditable={isEditable}
                isSpecialityEditing={item.isEditable && !isSpecialityAdd}
                value={departmentName}
                newValue={newSpecialityName}
                handleInputChanges={handleSpecialtyInputChanges}
                item={{ label: item.label }}
                handleIsEditableClick={handleEditClick}
                handleClose={handleCloseDepart}
                placeholderLg={t("placeholderSpeciality")}
                placeholderSm={t("placeholderSpecialitySm")}
                handleEditChange={() => {
                    setIsSpecialityEditPopUp(true);
                }}
                handleDelete={() => {
                    setIsSpecialityDelete(true);
                }}
                errorMessage={departmentNameErr}
            />
        </div >
    )
}

export default SpecialtyItem